 
import { Component, ElementRef, OnInit,ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { PeticionesService } from '../servicios/httpservice';
import Swal from 'sweetalert2';
import { LocalStorageService } from 'ngx-webstorage';
import { DataDBService } from '../servicios/data-db.service';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';


@Component({
  selector: 'app-partner-oferta-mes',
  templateUrl: './partner-oferta-mes.component.html',
  styleUrls: ['./partner-oferta-mes.component.css']
})
export class PartnerOfertaMesComponent implements OnInit {
  public arrayProductos:any = [ ];
  public strConexion:string ='COMERCIAL';
  constructor(private route: ActivatedRoute,elem: ElementRef,public localSt: LocalStorageService,public router: Router, private _httpService: PeticionesService,private indexedDBService: DataDBService,) { }

  ngOnInit(): void { 
    this.indexedDBService.getItem('arrayResult', (value) => {
      this.fnGetArticulos();
    })
    
  }

   fnGetArticulos() {
         
             this._httpService.mostrarCotizaciones({
               strAccion: 'GETOFERTAS', 
               strConexion: this.strConexion
             }, 'sp_PartNer').subscribe(
               result => { 
                 if (result.length > 0) {
                  console.log(result)
                  result.forEach(element => {
                    element.imagenUrl = "https://www.cleanclean.mx/imagenes/" + element.strArticulo +".JPG";
                  });
                  this.arrayProductos = result;
               
                 }  
               }, error => {
                 var error = <any>error;
                 console.log(error);
               });
           
         }
       

  comprarProducto(producto:any){
    localStorage.setItem('strArticulo_Seleccionado_Cotizador', JSON.stringify(producto));
   
    this.router.navigate(['/detalle_articulo']);
  }
}
